// Asymetric cryptography for Digital Signature
export async function generateKeyPair() {
  return await window.crypto.subtle.generateKey(
    {
      name: "RSASSA-PKCS1-v1_5",
      modulusLength: 2048,
      publicExponent: new Uint8Array([1, 0, 1]),
      hash: "SHA-256",
    },
    true,
    ["sign", "verify"],
  );
}

export async function hashReportContent(contentString) {
  const encoder = new TextEncoder();
  const data = encoder.encode(contentString);
  return await crypto.subtle.digest("SHA-256", data);
}

export async function signHash(privateKey, hashBuffer) {
  return await crypto.subtle.sign(
    { name: "RSASSA-PKCS1-v1_5" },
    privateKey,
    hashBuffer,
  );
}
// Public key
export async function exportPublicKeyToBase64(publicKey) {
  const exported = await crypto.subtle.exportKey("spki", publicKey);
  return bufferToBase64(exported);
}

// Private key
export async function exportPrivateKeyToBase64(privateKey) {
  const exported = await crypto.subtle.exportKey("pkcs8", privateKey);
  return bufferToBase64(exported);
}

export function bufferToBase64(buffer) {
  return btoa(String.fromCharCode(...new Uint8Array(buffer)));
}

export function base64ToBuffer(base64) {
  const binaryString = atob(base64);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}

export async function importPublicKeyFromBase64(base64) {
  const binaryDer = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
  return await window.crypto.subtle.importKey(
    "spki",
    binaryDer.buffer,
    {
      name: "RSASSA-PKCS1-v1_5",
      hash: "SHA-256",
    },
    false,
    ["verify"],
  );
}

export async function importPrivateKeyFromBase64(base64) {
  const binaryDer = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
  return await window.crypto.subtle.importKey(
    "pkcs8",
    binaryDer.buffer,
    {
      name: "RSASSA-PKCS1-v1_5",
      hash: "SHA-256",
    },
    false,
    ["sign"],
  );
}
